const PREFIX = "tazy_purchase_draft:";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function savePurchaseDraft(scope, data) {
  try {
    window.sessionStorage.setItem(`${PREFIX}${scope}`, JSON.stringify({ savedAt: Date.now(), data }));
  } catch (_) {
    // The buying flow still works when browser storage is unavailable.
  }
}

export function loadPurchaseDraft(scope) {
  try {
    const raw = window.sessionStorage.getItem(`${PREFIX}${scope}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.savedAt || Date.now() - parsed.savedAt > MAX_AGE_MS) {
      window.sessionStorage.removeItem(`${PREFIX}${scope}`);
      return null;
    }
    return parsed.data || null;
  } catch (_) {
    return null;
  }
}

export function clearPurchaseDraft(scope) {
  try {
    window.sessionStorage.removeItem(`${PREFIX}${scope}`);
  } catch (_) {
    // Nothing else is required.
  }
}
